export default __webpack_public_path__ + "static/media/home-corporate-img-04.0a126c57.jpg";